/**
 * Envío LMX-6 · semáforo de LMX y respuestas a preguntas (lógica pura, con tests).
 *   violeta = pregunta · ámbar = aprobar · azul = trabajando · verde = listo ·
 *   rojo = bloqueado. Ver claude/lmx-arquitectura.md §2.
 */
export const lmxAttention = ({ busy, pendingConfirm, cards }) => {
  if (pendingConfirm) return 'approve';
  if (busy) return 'working';
  const list = cards || [];
  // Envío LMX-T · «ya hay 2 trabajos»: también espera una decisión.
  if (list.some((c) => c?.type === 'question' || c?.type === 'jobs_full')) return 'question';
  // Envío LMX-6b · pausa por tope de pasos o turno largo: botón «Seguir».
  if (list.some((c) => c?.type === 'continue')) return 'continue';
  if (list.some((c) => c?.type === 'tag' && c.level === 'error')) return 'blocked';
  if (list.some((c) => c?.type === 'done')) return 'done';
  return 'idle';
};
export const ATTENTION_ICON = { question: '?', approve: '!', done: '✓', blocked: '×', working: '…', continue: '›' };
export const ATTENTION_LABEL = {
  question: 'LMX te hizo una pregunta', approve: 'LMX espera tu aprobación',
  done: 'LMX terminó', blocked: 'LMX se trabó y te propone una salida',
  continue: 'LMX hizo una pausa: tocá «Seguir»',
};

// Envío LMX-6b · qué decir en la franja de estado de la columna de LMX.
export const statusLine = ({ attention, busy, toolLabel, statusText, run }) => {
  if (busy) return toolLabel || statusText || 'Pensando…';
  if (run && run.total) return `Generando en el Canvas · ${run.done} de ${run.total} listos`;
  return {
    question: 'Te hice una pregunta: respondé abajo para que siga',
    approve: 'Espero tu OK para gastar créditos',
    continue: 'Hice una pausa: tocá «Seguir» y continúo',
    blocked: 'Me trabé: te propongo una salida abajo',
    done: 'Listo',
  }[attention] || '';
};

export const fmtElapsed = (ms) => {
  const s = Math.max(0, Math.floor((ms || 0) / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};


// Arma el mensaje de respuesta a partir de lo elegido en la tarjeta violeta.
export const composeAnswer = (questions, picked, other) => (questions || [])
  .map((q) => {
    const sel = [...(picked[q.id] || [])];
    const extra = (other[q.id] || '').trim();
    if (extra) sel.push(extra);
    return sel.length ? `${q.text} → ${sel.join(', ')}` : null;
  })
  .filter(Boolean)
  .join('\n');

